/*****************************************************************************************
 * 설명 : Header
*****************************************************************************************/
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { logout } from 'reducers/userReducer';

import { Restful } from 'service/restful';

import logo from 'assets/images/logo.png';
import noImg from 'assets/images/no_image.png';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const Header = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const dispatch = useDispatch();
  const [getApi] = Restful();

  const currentMenu = useSelector(state => state?.menuList?.current);
  const menuList = useSelector(state => state?.menuList?.list);
  const user = useSelector(state => state?.userInfo?.user);

  const [parentMenu, setParentMenu] = useState({});

  /***************************************************************************************
   * 설명 : 로그아웃 처리
  ***************************************************************************************/
  const setLogout = () => {

    if( ! window.confirm("로그아웃 처리 하시겠습니까?") ) return;

    let params = {
      program: 'api',
      service: 'member',
      action: 'logout',
      version: '1.0',
    }

    // 로그인 정보 및 사이트 정보 가져오기
    getApi("get", params).then( response => {
      if( response && response.data.result ) {
        // 토큰 삭제
        window.localStorage.removeItem('o2oz_token');
        window.localStorage.removeItem('o2oz_admin_token');

        // 로그아웃 처리
        dispatch(logout());
      }
    });
  }

  /***************************************************************************************
   * 설명 : 상위 메뉴 검색
  ***************************************************************************************/
  useEffect(() => {
    let tmp = menuList?.filter((item) => item?.pageCode === currentMenu?.pageCode?.substr(0, currentMenu?.pageCode?.length - 3));
    if( tmp && tmp.length > 0 )
      setParentMenu(tmp[0]);

    // eslint-disable-next-line
  }, [currentMenu]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <header className="admin-header admin-header-back">

      <NavLink to="/admin/dashboard" className="logo">
        <img src={logo} alt="o2oz 그룹웨어" />
        <span className="fl ml10 bold">O2OZ 그룹웨어</span>
      </NavLink>

      <div className="admin-header-path">
        <ul className="fl">
          <li>관리자</li>
          { parentMenu?.seq !== undefined &&
            <li>{parentMenu?.pageMenuName}</li>
          }
          <li>{currentMenu?.pageMenuName}</li>
        </ul>
      </div>

      <ul className="util-area">
        <li className="top-icon">
          <a href="/" target="_blank" rel="noreferrer" title="홈페이지">
            <span className="material-icons right-icon">home</span>
          </a>
        </li>
        <li className="top-icon" style={{color: '#555', lineHeight: '60px', width: '100px', fontSize: '18px', marginRight: '10px'}}>
          {user?.userName || user?.name} 님 !
        </li>

        <li className="login-info" onClick={() => {
          setLogout();
        }}>
          <img src={noImg} alt="로그아웃" />
        </li>
      </ul>
    </header>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Header;